module.exports = __webpack_public_path__ + "img/bag-check-fill.4e979425.svg";